// утилита возвращает sha-256 от строки
// если webcrypto subtle доступен (https или localhost), используем его
// иначе динамически подгружаем лёгкую реализацию crypto-js для работы на http стендах

const sha = async (data: string) => {
  if (typeof crypto !== 'undefined' && crypto.subtle && typeof crypto.subtle.digest === 'function') {
    const buffer = new TextEncoder().encode(data)
    const hashAsBuffer = await crypto.subtle.digest('SHA-256', buffer)
    const hashAsBytesArray = Array.from(new Uint8Array(hashAsBuffer))
    const hashAsHex = hashAsBytesArray.map((byte) => byte.toString(16).padStart(2, '0')).join('')
    return hashAsHex
  }

  // fallback: загружаем легкий polyfill только при необходимости
  const cryptoJs = await import('crypto-js')
  const hash = cryptoJs.SHA256(data).toString()
  return hash
}
export default sha
